import React from 'react';
import { makeStyles } from '@material-ui/styles';
import MuiTable from '@material-ui/core/Table';

import { secondary200 } from '../../../src/themes/colors';

const useStyles = makeStyles(theme => ({
  root: props => ({
    border: '0.063rem solid',
    borderColor: secondary200,
    borderRadius: props.noRadius ? '0' : '0.375rem',
    borderCollapse: 'separate !important',
    '& .rectangle-cell': {
      userSelect: 'none',
      '& .rectangle-cell__container': {
        display: 'inline-flex',
        flexDirection: 'column',
      },
      '& .rectangle-cell__item': {
        backgroundColor: theme.palette.secondary['100'],
        padding: '2px 5px',
        borderRadius: '15px',
        whiteSpace: 'nowrap',
        display: 'inline-block',
      },
      '& p': {
        textAlign: 'center',
      },
      '& svg': {
        transition: 'none',
        cursor: 'initial',
        '&:hover': {
          opacity: '0.7',
        },
      },
    },
    '&$loading': {
      position: 'relative',
      '& tbody::after': {
        top: '0',
        left: '0',
        right: '0',
        bottom: '0',
        content: "''",
        position: 'absolute',
        width: '100%',
        height: '100%',
        backgroundColor: theme.palette.secondary['100'],
      },
    },
  }),
}));

const Table = (props) => {
  const { loading } = props;
  const classes = useStyles(props);
  return (
    <MuiTable
      classes={{
        root: classes.root,
        loading: loading ? classes.loading : null,
      }}
      {...props}
    >
      {props.children}
    </MuiTable>
  );
};

export default Table;
